import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class ItemSelectionService {
    constructor() {
        this._items = {};
        this.items = new BehaviorSubject({});
        this.items$ = this.items.asObservable();
    }
    get numSelectedItems() {
        return Object.keys(this._items).length;
    }
    get selectedItem() {
        if (this.numSelectedItems <= 0) {
            return undefined;
        }
        if (this.numSelectedItems > 1) {
            throw new Error('There is more than one selected item');
        }
        return Object.entries(this._items)[0][1];
    }
    get selectedItems() {
        return Object.entries(this._items).map((entry) => entry[1]);
    }
    hasSelectedItems() {
        return this.numSelectedItems > 0;
    }
    isSelected(item) {
        return item.id in this._items;
    }
    selectItem(item) {
        if (this.isSelected(item))
            return;
        this._items[item.id] = item;
        this.items.next(this._items);
    }
    selectItems(items) {
        items.forEach((item) => {
            if (!this.isSelected(item)) {
                this._items[item.id] = item;
            }
        });
        this.items.next(this._items);
    }
    deselectItem(item) {
        if (!this.isSelected(item))
            return;
        delete this._items[item.id];
        this.items.next(this._items);
    }
    clearSelections() {
        this._items = {};
        this.items.next(this._items);
    }
    toggleSelectedItem(item) {
        if (this.isSelected(item)) {
            this.deselectItem(item);
        }
        else {
            this.selectItem(item);
        }
    }
}
ItemSelectionService.ɵfac = function ItemSelectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ItemSelectionService)(); };
ItemSelectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ItemSelectionService, factory: ItemSelectionService.ɵfac });
